module.exports = "<footer class=\"text-center\">\r\n    <div style=\"padding: 10px\">Copyright © {{getYear()}} <a href=\"http://www.smithweb.com\">Smith & Asociates</a>. All Rights Reserved</div>\r\n    <div style=\"padding: 10px; font-size: 13px\">Last data refresh was on {{refreshDate | date : 'MMM dd yyyy, hh:mm:ss a'}} US Central Time</div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main